// extracted by mini-css-extract-plugin
module.exports = {"action":"_3zpPxa","icon":"_3UjPO1","thumbUp":"_1HT8h3","thumbDown":"Z7WZmH","active":"_2YBJmj","shine-lines":"_1Bus0Q"};